import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import './charges-list.scss';
import EmptyIcon from "@mui/icons-material/MenuOpenTwoTone";
import axios from '../../../../../../../../api/axios';
import ChargesCard from '../cards/charges _card';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function ChargesList() {
  const restaurant_id = sessionStorage.getItem("configBizEntityId");

  const [searchTerm, setSearchTerm] = useState('');
  const [charges, setCharges] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [newChargeName, setNewChargeName] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [editMode, setEditMode] = useState(false);
  const [editChargeId, setEditChargeId] = useState(null);

  const handleSnackbarClose = () => setOpenSnackbar(false);

  const fetchCharges = async () => {
    try {
      const response = await axios.get(`businessEntities/getExtraCharges/${restaurant_id}`, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });
      setCharges(response.data.charges || []);
    } catch (error) {
      console.error('Error fetching charges:', error);
    }
  };

  useEffect(() => {
    fetchCharges();
  }, [restaurant_id]);

  const handleAddCharge = () => {
    setEditMode(false);
    setNewChargeName('');
    setOpenModal(true);
  };

  const handleEditCharge = (id, name) => {
    setEditMode(true);
    setEditChargeId(id);
    setNewChargeName(name);
    setOpenModal(true);
  };

  const handleCloseModal = () => setOpenModal(false);

  const handleAddOrUpdateSubmit = async () => {
    if (!newChargeName) {
      setSnackbarMessage("Charge name is required.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      return;
    }

    try {
      const payload = { name: newChargeName, restaurant_id };
      let response;

      if (editMode) {
        response = await axios.put(`businessEntities/extraChargeUpdate/${editChargeId}`, payload, {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        });
      } else {
        response = await axios.post('businessEntities/addExtraCharge', payload, {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        });
      }

      if (response.status === 200 || response.status === 201) {
        setSnackbarMessage(editMode ? "Charge updated successfully!" : "Charge added successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }

      setOpenModal(false);
      fetchCharges();
    } catch (error) {
      console.error("Error:", error);
      setSnackbarMessage(editMode ? "Error updating charge." : "Error adding charge.");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`businessEntities/extraChargeUpdateDelete/${id}`);
      if (response.status === 200) {
        fetchCharges();
        setSnackbarMessage("Charge deleted successfully");
        setSnackbarSeverity('success');
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting charge:", error);
      setSnackbarMessage("Failed to delete charge");
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const filteredCharges = charges.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="wrap">
      <div className="roww">
        <div className="search">
          <input
            type="text"
            className="searchTerm"
            placeholder="Search charge"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={handleAddCharge}
            style={{ backgroundColor: '#4CAF50', color: 'white', marginLeft: '10px' }}
          >
            Add Charge
          </Button>
        </div>

        {searchTerm !== '' && filteredCharges.length === 0 && charges.length !== 0 && (
          <div className="no-match-found">
            <EmptyIcon className="icon" />
            <span className="message">No match found for your charge search!</span>
          </div>
        )}
        {charges.length === 0 && (
          <div className="no-match-found">
            <EmptyIcon className="icon" />
            <span className="message">No charges added yet</span>
          </div>
        )}
      </div>

      <Grid container spacing={3}>
        {filteredCharges.map(item => (
          <Grid item key={item.id} xs={12} sm={6} md={4} lg={3}>
            <ChargesCard
              name={item.name}
              onEdit={() => handleEditCharge(item.id, item.name)}
              onDelete={() => handleDelete(item.id)}
            />
          </Grid>
        ))}
      </Grid>

      <Modal open={openModal} onClose={handleCloseModal}>
        <div className="modal-container">
          <h6>{editMode ? "Edit Charge" : "Add New Charge"}</h6>
          <div>
            <label htmlFor="charge-name">Charge Name:</label>
            <input
              id="charge-name"
              type="text"
              value={newChargeName}
              onChange={(e) => setNewChargeName(e.target.value)}
            />
          </div>
          <Button
            style={{ marginTop: '10px', float: 'right' }}
            variant="contained"
            onClick={handleAddOrUpdateSubmit}
          >
            Save
          </Button>
        </div>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}

export default ChargesList;
